import cx from 'classnames';
import { bool, string } from 'prop-types';

import { eventGtag } from '#app/hooks/eventGtag';
import { eventFb } from '#app/hooks/eventFb';
import { useUserContext } from '#hooks/index';
import { event } from '#helpers/gtag';

const WhatsAppLogo = ({ fixLanding = false, msg, eventNameAnalytics }) => {
  const { data: userData } = useUserContext();
  const number = '17867892469';
  const url = msg
    ? `https://api.whatsapp.com/send/?phone=&text=${msg}`
    : `https://api.whatsapp.com/send?phone=${number}`;

  const trackingGAEvent = () => {
    event(
      'whatsapp_button_click',
      'customer_contact',
      'Consulta de un cliente por whatsapp'
    );
    if (eventNameAnalytics) {
      eventGtag(eventNameAnalytics, userData);
      eventFb(eventNameAnalytics, userData);
    }
  };

  return (
    <a
      href={url}
      className={cx('whatsapp-main-icon', { fixLanding })}
      target="_blank"
      rel="noreferrer"
      onClick={trackingGAEvent}
    >
      <svg
        width="64"
        height="66"
        viewBox="0 0 64 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.9155 56.1935L17.9617 56.7167C22.3217 59.3324 27.2044 60.5531 32.0873 60.5531C47.4333 60.5531 59.9891 47.9973 59.9891 32.6513C59.9891 25.3272 57.0244 18.1773 51.793 12.9456C46.5613 7.71396 39.5857 4.74951 32.0873 4.74951C16.7413 4.74951 4.18521 17.3053 4.35971 32.8258C4.35971 38.0572 5.92918 43.1147 8.54489 47.4741L9.24238 48.5206L6.45242 58.8094L16.9155 56.1935Z"
          fill="#25D366"
        />
        <path
          d="M54.7574 10.1554C48.8282 4.05197 40.6321 0.738525 32.2615 0.738525C14.4743 0.738525 0.174497 15.2125 0.348745 32.8255C0.348745 38.4059 1.91822 43.8121 4.53418 48.6948L0 65.2615L16.9155 60.9018C21.6239 63.5178 26.8553 64.7385 32.0872 64.7385C49.7002 64.7385 64 50.2642 64 32.6515C64 24.1064 60.6866 16.0845 54.7576 10.1554H54.7574ZM32.2615 59.3326C27.5531 59.3326 22.8446 58.1121 18.8337 55.6707L17.7875 55.1474L7.67313 57.7631L10.2888 47.8233L9.59135 46.7768C1.91822 34.3955 5.58041 18.0028 18.1362 10.3296C30.692 2.65675 46.91 6.31894 54.5831 18.8747C62.256 31.4305 58.5938 47.6485 46.0383 55.3217C42.0271 57.9374 37.1444 59.3324 32.2615 59.3324V59.3326ZM47.6075 39.9759L45.6893 39.1039C45.6893 39.1039 42.8993 37.8832 41.1554 37.0112C40.9809 37.0112 40.8066 36.8367 40.6321 36.8367C40.1089 36.8367 39.7601 37.0112 39.4114 37.1857C39.4114 37.1857 39.2371 37.36 36.7957 40.1502C36.6212 40.4989 36.2724 40.6734 35.9237 40.6734H35.7492C35.5749 40.6734 35.2262 40.4989 35.0517 40.3247L34.1797 39.9759C32.2615 39.1039 30.5178 38.0574 29.1225 36.6625C28.7738 36.3137 28.2506 35.965 27.9018 35.6162C26.6811 34.3955 25.4604 33.0003 24.5886 31.4308L24.4141 31.082C24.2399 30.9076 24.2399 30.7333 24.0654 30.3846C24.0654 30.0358 24.0654 29.6871 24.2399 29.5126C24.2399 29.5126 24.9374 28.6406 25.4604 28.1176C25.8093 27.7686 25.9836 27.2456 26.3323 26.8969C26.6811 26.3736 26.8556 25.6761 26.6811 25.1529C26.5068 24.2809 24.4141 19.5725 23.8911 18.5262C23.5421 18.003 23.1936 17.8288 22.6704 17.6543H20.7522C20.4032 17.6543 20.0547 17.8288 19.7057 17.8288L19.5312 18.003C19.1825 18.1775 18.8337 18.5262 18.485 18.7005C18.1362 19.0495 17.9617 19.398 17.613 19.747C16.3922 21.3165 15.6948 23.2347 15.6948 25.1529C15.6948 26.5479 16.0435 27.9431 16.5667 29.1638L16.7412 29.6871C18.3107 33.0003 20.4032 35.965 23.1936 38.5807L23.8911 39.2782C24.4141 39.8014 24.9374 40.1502 25.2861 40.6731C28.9483 43.8123 33.1335 46.0793 37.8419 47.3C38.3652 47.4743 39.0626 47.4743 39.5859 47.6488H41.3296C42.2016 47.6488 43.2478 47.3 43.9456 46.9513C44.4686 46.6026 44.8173 46.6026 45.166 46.2538L45.515 45.9048C45.8638 45.5561 46.2125 45.3818 46.5613 45.0331C46.91 44.6843 47.2588 44.3356 47.4333 43.9866C47.782 43.2891 47.9563 42.4171 48.1307 41.5454V40.3247C48.1307 40.3247 47.9562 40.1502 47.6075 39.9759Z"
          fill="white"
        />
      </svg>

      <p>¡Hola! 👋 Resolvemos todas tus dudas.</p>
    </a>
  );
};

WhatsAppLogo.propTypes = {
  fixLanding: bool,
  msg: string
};

export default WhatsAppLogo;
